import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";

export default function RoundupSpotlight() {
  const featured = topics[0];
  const secondaries = topics.slice(1, 4);

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Annual Roundup"
        title="年度盘点焦点"
        desc="一年话题的起点与终点都在这里。先看总盘点建立框架，再顺着时间线往下读。"
        actionPath="/rankings"
        actionLabel="查看全部盘点"
      />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
        <article className="relative rounded-lg overflow-hidden bg-background-100">
          <div className="relative w-full aspect-[16/10]">
            <img
              src={featured.cover}
              alt={`${featured.title} — 年度盘点焦点封面`}
              className="w-full h-full object-cover object-top"
            />
            <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
              年度总盘点
            </span>
          </div>
          <div className="p-5 md:p-7">
            <h3 className="font-heading font-bold text-xl md:text-2xl leading-snug text-foreground-950">
              <Link to={`/topic/${featured.slug}`} className="hover:text-primary-600 transition-colors">
                {featured.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>

            <ul className="mt-5 space-y-2.5">
              {featured.highlights.map((point) => (
                <li key={point} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-600 mt-0.5 flex-shrink-0">
                    <i className="ri-bookmark-3-line" />
                  </span>
                  {point}
                </li>
              ))}
            </ul>

            <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span>{featured.author}</span>
                <span className="w-px h-3 bg-background-300" />
                <span>{featured.readTime}</span>
                <span className="w-px h-3 bg-background-300" />
                <span>{featured.publishedAt}</span>
              </div>
              <Link
                to={`/topic/${featured.slug}`}
                className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </article>

        <div className="flex flex-col gap-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {secondaries.slice(0, 2).map((topic) => (
              <TopicCard key={topic.slug} topic={topic} />
            ))}
          </div>

          <div className="rounded-lg border border-background-200 p-5">
            <h4 className="font-heading font-bold text-base text-foreground-950 mb-1">
              <i className="ri-history-line text-primary-500 mr-1.5" />
              后续追踪
            </h4>
            <p className="text-xs text-foreground-500 mb-3">
              当事方有新回应或话题有进展时，我们会回到原文补充与更正。
            </p>
            <div className="divide-y divide-background-200">
              {topics.slice(0, 4).map((topic) => (
                <TopicCard key={topic.slug} topic={topic} variant="compact" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}